const confirmForgotPasswordES = {
	title: "Restablecer contraseña",
	subtitle: "Introduce el código que te enviamos y elige una nueva contraseña.",
	email: "Correo electrónico",
	code: "Código de confirmación",
	password: "Nueva contraseña",
	confirmPassword: "Confirmar contraseña",
	submit: "Restablecer contraseña",
	submitting: "Actualizando...",
	success: "¡Listo! Tu contraseña se actualizó correctamente.",
	toast: {
		required: "Completa todos los campos para continuar.",
		weakPassword:
		"Tu nueva contraseña necesita al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.",
		mismatch: "Las contraseñas no coinciden. Revísalas e inténtalo de nuevo.",
		invalidCode: "Ese código no es válido o ya expiró. Solicita uno nuevo.",
		error: "No pudimos restablecer tu contraseña. Inténtalo de nuevo.",
	},
};

export default confirmForgotPasswordES;
